
export const INTERNAL_LINKS = [
  { link: 'https://www.toptal.com/marketing/social-media-managers', label: 'Social Media Manager' },
  { link: 'https://www.toptal.com/marketing/copywriters', label: 'Copywriter' },
  {
    link: 'https://www.toptal.com/marketing/search-engine-optimization',
    label: 'SEO Expert'
  },
  { link: 'https://www.toptal.com/marketing/digital', label: 'Digital Marketer' },
  {
    link: 'https://www.toptal.com/marketing/keyword-research',
    label: 'Keyword Researcher'
  },
  {
    link: 'https://www.toptal.com/marketing/on-page-seo-optimization',
    label: 'On-Page SEO Expert'
  },
  { link: 'https://www.toptal.com/marketing/semrush', label: 'SEMrush Expert' },
  {
    link: 'https://www.toptal.com/marketing/seo-audit',
    label: 'SEO Audit Specialist'
  },
  { link: 'https://www.toptal.com/marketing/local-seo', label: 'Local SEO Expert' },
  { link: 'https://www.toptal.com/marketing/seo-copywriting', label: 'SEO Copywriter' },
  {
    link: 'https://www.toptal.com/marketing/search-engine-marketing',
    label: 'SEM Expert'
  },
  { link: 'https://www.toptal.com/marketing/link-building', label: 'Link Builder' },
  {
    link: 'https://www.toptal.com/marketing/amazon-seo',
    label: 'Amazon SEO Expert'
  },
  { link: 'https://www.toptal.com/marketing/off-page-seo', label: 'Off-Page SEO Specialist' },
  { link: 'https://www.toptal.com/marketing/ppc-advertising', label: 'PPC Expert' }
]
